module.exports = __webpack_public_path__ + "static/media/sociall.329620f3.svg";